import { Origin } from "@/constants/share";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import { IStreamCloseMap } from "@/types/summary";
import { useEffect, useRef } from "react";
import usePollingSummary from "./usePollingSummary";

const useFetchSummaryStream = (streamId?: string) => {
  const streamCloseMap = summaryStore((state) => state.streamCloseMap);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const firstFlag = useRef(true);
  const streamCloseMapRef = useRef<IStreamCloseMap>();
  streamCloseMapRef.current = streamCloseMap;

  const commonInitParam = {
    streamName: `live/${streamId}`,
    reload: false,
    contentStep: "SRC_DOC",
    cover: true,
  };

  const { pollingSummary } = usePollingSummary(commonInitParam);


  const fetchCompletedSummary = async () => {
     // 从板端流转过来的，走轮询
    if(shareInfo?.origin === Origin.MEETING_PLATE || detailInfo?.originType === Origin.MEETING_PLATE || detailInfo?.originType === Origin.PLATE_SHARE) {
      pollingSummary();
      return;
    }

    // 个人端流转，从详情接口获取纪要是否总结完成，因为详情summaryFinish为true时纪要一定总结完成了
    if (detailInfo?.summaryFinish) {
      summaryStore.getState().setSummaryLoading(true);
      await summaryStore.getState().fetchSummary(commonInitParam);
      summaryStore.getState().setSummaryStreamsAllDone(true);
      summaryStore.getState().setSummaryLoading(false);
      return;
    }
    summaryStore.getState().setSummaryStreamsAllDone(false);
    summaryStore.getState().fetchSummaryStreams(commonInitParam, () => {
      summaryStore.getState().setSummaryStreamsAllDone(true);
      const { detailInfo } = summarySrcStore.getState();
      if (detailInfo) {
        summarySrcStore.getState().setDetailInfo({
          ...detailInfo,
          summaryFinish: true,
        });
      }
    });
  };

  useEffect(() => {
    if (!streamId || !detailInfo || !firstFlag.current) return;
    firstFlag.current = false;
    summaryCommonStore.getState().setFullLoading(false);
    // 根据是否总结完成决定调用流式接口还是非流式接口
    fetchCompletedSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [streamId, detailInfo]);

  useEffect(() => {
    return () => {
      if (streamCloseMapRef.current) {
        Object.values(streamCloseMapRef.current).forEach((item) => {
          item.closeMethod && item.closeMethod();
        });
      }
    };
  }, []);

  const loading = retryStatus === 1;

  return { loading };
};

export default useFetchSummaryStream;
